import update from 'immutability-helper';
import { TOGGLE_SIDEBAR_COLLAPSE } from './layout-actions';

const initialState = {
  modalOpen: false,
  sidebarCollapsed: false
};

function layoutReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR_COLLAPSE:
      return update(state, {
        sidebarCollapsed: {$set: !state.sidebarCollapsed}
      });
    default:
      return state
  }
}

export default layoutReducer;



// WEBPACK FOOTER //
// ./src/components/layout/layout-reducer.js